import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import Carousel from "react-bootstrap/Carousel";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/locationgcc/dxb/ae/slider_banner.png";

const Casebanner = () => {
  return (
    <Carousel indicators={false} pause={false} className="case_landing_slider">
      <Carousel.Item
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/ozleasing.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={915}
                    height={660}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Automotive</h5>
                  <h2>OZ Leasing</h2>
                  <h4>465X Return on Investments</h4>
                  <p>
                    OZ Leasing, a disruptive tech start-up, aims to simplify car
                    leasing in the automotive industry. Our team developed a
                    comprehensive web and mobile app solution, streamlining the
                    leasing process for users.
                  </p>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
      <Carousel.Item
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/alhussaini.webp"
                    alt="alhussaini"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={936}
                    height={738}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Retail</h5>
                  <h2> Al Hussaini Trading Company</h2>
                  <h4>73% Increase in Online Sales</h4>
                  <p>
                    Al Hussaini Trading Company, a prominent marketplace for
                    watches, jewelry, and leather goods in Saudi Arabia,
                    partnered with us to elevate their online retail presence.
                    We developed a responsive web and app solution to redefine
                    the digital retail experience.
                  </p>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
      <Carousel.Item
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/linkfornt.webp"
                    alt="linkfornt"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={881}
                    height={686}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Fashion</h5>
                  <h2>Linkfront</h2>
                  <h4>170X Growth in User Engagement</h4>
                  <p>
                    Linkfront, an innovative shopping web app, approached us to
                    redefine the online retail landscape. We created a dynamic
                    platform that seamlessly integrates with e-commerce
                    websites, offering users a unified shopping experience.
                  </p>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
      <Carousel.Item
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/mdrouz.webp"
                    alt="mdrouz"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={880}
                    height={637}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>E-Commerce</h5>
                  <h2>Mdrouz</h2>
                  <h4>Diverse Fashion Trends, Multi-vendor Support</h4>
                  <p>
                    Mdrouz's dynamic web platform offers a one-stop destination
                    for fashion, featuring diverse stores with unique
                    collections and multi-vendor support.
                  </p>
                  <Link to="/case-studies/mdrouz">View Case study</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
      <Carousel.Item
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                <div className="case_img">
                  <StaticImage
                    src="../../../images/locationgcc/casestudy/onsite.webp"
                    alt="onsite"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={879}
                    height={674}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={5}
                xxl={5}
                className="my-auto offset-xl-1"
              >
                <div className="case_content case_content_ae">
                  <h5 style={{ marginBottom: "0px" }}>Public Relations</h5>
                  <h2>Onsite</h2>
                  <h4>47% Increase in User Connections</h4>
                  <p>
                    Onsite's revolutionary social media platform redefined
                    real-time connections
                  </p>
                  <Link to="/case-studies/onsite">View Case study</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
    </Carousel>
  );
};

export default Casebanner;
